var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 91 91"
    },
    viewBox: "0 0 91 91",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#262626;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.9,10.2c-14,3.4-27.9,1.2-41.7-2c-3.1-0.7-5.5,4-2.3,5.4c6.6,3,13.1,5.2,19.8,6.4   c-11.1,5.2-21,12.7-25.5,23.9c-18.7,0.7-29.9,15-28,33.7c0.3,2.7,4.4,2.9,4.3,0c-0.1-10,6.6-21.6,16.4-24.3c1.5-0.4,3.2-0.7,5-0.9   c-1,8,0.9,15.8,6.7,21.9c5.7,6,13.5,5.5,19.9,0.3c6.7-5.6,5.9-13.8,1.3-20.6c-3.7-5.5-9-8.1-14.8-9.3c1.9-2.8,4.2-5.3,7.1-7.3   c6.2-4.4,13.4-7.6,20.7-10.2c-3.4,7.2-6,14.9-5.8,21.8c0.2,6.5,9.6,6.4,10,0c0.7-11,6.3-22.9,12.1-32.1   C89.4,13.5,85.7,9.3,81.9,10.2z M53.2,61.6c1.7,5.4-3.7,12.2-9.8,8.9c-5.7-3.1-5.4-12.5-4-18c1.8,0.2,3.6,0.6,5.1,1.1   C48.1,54.9,52,57.8,53.2,61.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9b20ec30f759a8956886c0dd8b9b048e.svg";
export { ForwardRef as ReactComponent };